import { render, staticRenderFns } from "./occupations.vue?vue&type=template&id=64f1eecb&scoped=true&"
import script from "./occupations.vue?vue&type=script&lang=ts&"
export * from "./occupations.vue?vue&type=script&lang=ts&"
import style1 from "./occupations.vue?vue&type=style&index=1&id=64f1eecb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f1eecb",
  null
  
)

export default component.exports